import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { NagNameAlias } from './../../../../../common-services/a3i-nag.service';

export interface NagAliasModalData {
	action: 'add' | 'edit';
	alias?: NagNameAlias;
}

@Component({
	selector: 'app-nag-alias-modal',
	templateUrl: './nag-alias-modal.component.html',
	styleUrls: ['./nag-alias-modal.component.css']
})
export class NagAliasModalComponent implements OnInit {

	public title: string;
	public aliasName: string;
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: NagAliasModalData,
		public dialogRef: MatDialogRef<NagAliasModalComponent>
	) { }

	cancel() {
		this.dialogRef.close(null);
	}
	apply() {
		// Close modal
		this.dialogRef.close(this.aliasName);
	}
	ngOnInit() {
		this.title = this.data.action === 'add' ? 'New Alias' : 'Update Alias';
		this.aliasName = this.data.alias ? this.data.alias.name : '';
	}

}



// WEBPACK FOOTER //
// ./src/app/components/portal/a3i-setting/a3i-nag/nag-alias-modal/nag-alias-modal.component.ts